





import { Vue, Component, Prop} from 'vue-property-decorator';
import {SeparatorConfig} from "@/types/ReservationCardConfig";


@Component
export default class ReservationCard extends Vue {

  @Prop({
    type: Object,
    default: {
      text: "Chargement en cours ...",
      isMonthDisplayed: true
    }
  })
  public title!: SeparatorConfig;

}

